import { store } from "@/store/store";
import { VuexModule, getModule, Module, Action } from "vuex-module-decorators";
import { ssmHttpService } from "@/shared/services/http-service";
import { API } from "@/shared/api";

@Module({
  namespaced: true,
  name: "solicitudesWorkflowModule",
  store,
  dynamic: true,
})
class SolicitudesWorkflowModule extends VuexModule {
  @Action
  public async getCatalogosAdmin() {
    return await ssmHttpService.get(API.solicitudesWorkflow + "/admin/catalogos");
  }

  @Action
  public async getTableroAdmin(filters?: any) {
    return await ssmHttpService.get(API.solicitudesWorkflow + "/admin/tablero", { params: filters || {} });
  }

  @Action
  public async crearAdmin(payload: any) {
    return await ssmHttpService.post(API.solicitudesWorkflow + "/admin/crear", payload);
  }

  @Action
  public async getDetalleAdmin(id: number) {
    return await ssmHttpService.get(API.solicitudesWorkflow + "/admin/" + id + "/detalle");
  }

  @Action
  public async accionAdmin(payload: { id: number; accion: any }) {
    return await ssmHttpService.post(
      API.solicitudesWorkflow + "/admin/" + payload.id + "/accion",
      payload.accion
    );
  }

  @Action
  public async actualizarSolicitudAdmin(payload: { id: number; solicitud: any }) {
    return await ssmHttpService.put(API.solicitudes_cita + "/" + payload.id, payload.solicitud);
  }

  @Action
  public async getPacienteLead(id: number) {
    return await ssmHttpService.get(API.pacientes_leads + "/" + id);
  }

  @Action
  public async actualizarPacienteLead(payload: { id: number; paciente: any }) {
    return await ssmHttpService.put(API.pacientes_leads + "/" + payload.id, payload.paciente);
  }

  @Action
  public async notificarModificacionWhatsapp(id: number) {
    return await ssmHttpService.post(API.solicitudesWorkflow + "/admin/" + id + "/notificar-modificacion", {});
  }

  // Búsqueda de pacientes-leads por texto (nombre, teléfono, documento, email)
  @Action
  public async buscarPacientes(q?: string) {
    return await ssmHttpService.get(API.pacientes_leads + "/buscar", { params: { q: q || "" } });
  }

  // Actualización de fechas de una solicitud (drag & drop / resize en el calendario)
  // Carga el detalle completo y hace PUT con las nuevas fechas calculadas
  @Action
  public async actualizarFechasSolicitud(payload: {
    id: number;
    fecha_hora_inicio: string;
    fecha_hora_fin: string;
    duracion_minutos: number;
  }) {
    // Primero obtenemos el detalle para tener el DTO completo
    const detResRaw: any = await ssmHttpService.get(API.solicitudesWorkflow + "/admin/" + payload.id + "/detalle");
    const sol = (detResRaw && detResRaw.data) ? detResRaw.data.solicitud : undefined;
    if (!sol) throw new Error("No se pudo obtener la solicitud");

    // PUT sobre el CRUD base con los campos de fecha actualizados
    return await ssmHttpService.put(API.solicitudes_cita + "/" + payload.id, {
      ...sol,
      fecha_hora_inicio_solicitada: payload.fecha_hora_inicio,
      fecha_hora_fin_solicitada: payload.fecha_hora_fin,
      duracion_minutos: payload.duracion_minutos,
    });
  }
}

export default getModule(SolicitudesWorkflowModule);
